import { useMemo } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import RadioGroup from "../Radio/RadioGroup";
import { Filter } from "./CustomFilters";

const activeOptions = [
  { id: 0, value: undefined }, // All
  { id: 1, value: "True" }, // Active
  { id: 2, value: "False" }, // Inactive
];

export const CustomActiveFilter = ({
  item,
  onChange,
  disabled,
}: {
  item: Filter;
  onChange: (item: Filter) => void;
  disabled?: boolean;
}) => {
  const t = useTranslations();

  const radioItems = useMemo(
    () =>
      activeOptions.map((o) => ({
        id: o.id,
        value: `object-active-${o.id}`,
        text: t(`Objects:object-active_${o.id}`),
      })),
    [],
  );

  const selectedLinkedOption = activeOptions.find(
    (o) => o.value === item.value,
  );
  const selectedRadioItem = radioItems.find(
    (i) => i.id === (selectedLinkedOption?.id || 0),
  );

  return (
    <RadioGroup
      step={20}
      label={t("Objects:active_object")}
      name="object-active"
      items={radioItems}
      selectedValue={selectedRadioItem?.value}
      disabled={disabled}
      wrapperStyle={{ flexDirection: "row", gap: "24px" }}
      onChange={(value) => {
        const radioItem = radioItems.find((i) => i.value === value);
        const activeOption = activeOptions.find((o) => o.id === radioItem?.id);

        onChange({
          ...item,
          value: activeOption?.value,
        });
      }}
    />
  );
};
